import { createTheme } from "@material-ui/core/styles";
import { fontFamily } from "@material-ui/system";

const theme = createTheme({
  palette: {
    primary: {
      main: "#083535",
    },
    secondary: {
      main: "#48b38f",
    },

    info: {
      main: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "apercu-condensed-bold-pro, Verdana, sans-serif",
    fontSize: 17,
    h1: {
      fontSize: 30,
      fontWeight: 700,
    },
    h2: {
      fontSize: 24,
    },
    h3: {
      fontSize: 18,
      fontWeight: 700,
      lineHeight: 1,
    },
    h4: {
      fontSize: 15,
      fontWeight: 500,
      lineHeight: 1,
    },
    h5: {
      fontSize: 22,
      fontWeight: 700,
    },
    body2: {
      fontFamily: "apercu-condensed-regular-pro, Verdana, sans-serif",
      fontSize: 14,
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: 12,
      fontFamily: ["apercu-condensed-regular-pro, Verdana, sans-serif"].join(
        ","
      ),
    },
    subtitle2: {
      fontSize: 14,
      fontFamily: ["apercu-condensed-regular-pro, Verdana, sans-serif"].join(
        ","
      ),
      fontWeight: 500,
    },
  },
  overrides: {
    MuiAccordion: {
      root: {
        "&:before": {
          content: "none",
        },
        "&.Mui-expanded": {
          margin: 0,
        },
      },
      rounded: {
        borderRadius: 15,
        boxShadow: "0 1px 3px rgba(0, 0, 0, .12)",
        width: "100%",
      },
    },
    MuiAccordionSummary: {
      root: {
        display: "flex",
        "& .MuiAccordionSummary-expandIcon": {
          color: "var(--color-primary)",
        },
      },
      content: {
        margin: "15px 0",
        "&.Mui-expanded": {
          margin: "15px 0",
        },
      },
    },
    MuiSvgIcon: {
      fontSizeSmall: {
        fontSize: 20,
      },
    },
    MuiCard: {
      root: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        padding: 15,
        borderRadius: 15,
        boxShadow: "0 1px 3px rgba(0, 0, 0, .12)",
      },
    },
    MuiBackdrop: {
      root: {
        zIndex: 0,
        backgroundColor: "rgba(100, 100, 100, 0.5) !important",
      },
    },
    MuiFormControl: {
      root: {
        width: "100%",
      },
    },
    MuiSelect: {
      root: {
        fontSize: 14,
        fontFamily: ["apercu-condensed-regular-pro, Verdana, sans-serif"].join(
          ","
        ),
      },
    },
    MuiButton: {
      root: {
        color: "#64FFC7",
        borderRadius: 30,
        textTransform: "none",
        fontSize: 18,
        padding: "4px 30px",
      },
      containedPrimary: {
        color: "#fff",
      },
      containedSecondary: {
        color: "#FFFFFF",
      },
    },
    MuiBottomNavigation: {
      root: {
        height: 76,
        backgroundColor: "#083535",
        paddingTop: 10,
        paddingBottom: 10,
      },
    },
    MuiBottomNavigationAction: {
      root: {
        color: "#FFFFFF",
        padding: 0,
      },
      label: {
        fontFamily: "FoundryGridnik-Regular, Verdana, sans-serif",
      },
    },
    MuiFilledInput: {
      root: {
        borderRadius: 5,
      },
    },
    MuiFormHelperText: {
      root: {
        color: "red",
      },
    },
    MuiSnackbarContent: {
      message: {
        fontSize: "12pt",
      },
    },
    MuiInputBase: {
      root: {
        "&$disabled": {
          backgroundColor: "#c7c7c7",
          color: "#c7c7c7",
        },
        borderBlockColor: "red",
      },
    },
    MuiDialogTitle: {
      root: {
        padding: 0,
        fontWeight: "bold",
      },
    },
    MuiDialogContentText: {
      root: {
        fontSize: 16,
        lineHeight: 1,
      },
    },
  },
});

export default theme;
